import * as React from 'react';
import { SVGProps } from 'react';

const SvgCloseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg"
      className="dropdown__close"
      {...props}
    >
      <path
        d="m12 10.586 4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636l4.95 4.95Z"
        fill="#fff"
      />
    </svg>
  );
};
export default SvgCloseIcon;
